module.exports = __webpack_public_path__ + "media/images/logo_asahi-7c62f878a50916d75ac16b09fefbcefc.png";